/* eslint-disable */
import Swiper from 'swiper/bundle'
import Cookieconsent from 'vanilla-cookieconsent'

export default {
    init() {
        // JavaScript to be fired on all pages
        let scroll = $(window).scrollTop();

        $(window).scroll(function () {
            scroll = $(window).scrollTop();
            posHeader();
        });


        // HEADER
        $('.js_toggle-menu').on('click', function () {
            $(this).toggleClass('close');
            $('body').toggleClass('menu-active');
        });

        $('.js_btn-toggle-search').on('click', function () {
            $('body').toggleClass('search-active');
            setTimeout(function () {
                if ($('body').hasClass('search-active')) {
                    $('.search-form .search-field').focus();
                }
            }, 100);
        });

        let position = $(window).scrollTop();
        let keepHeaderVisible = false;
        let headerSticky = 0;
        let $header = $('#header');
        let headerHeight;

        function posHeader()
        {
            headerHeight = $header.outerHeight(true);

            if (scroll == 0) {
                $('body').removeClass('scroll-up scroll-down');
            } else if (scroll > position) {
                $('body').addClass('scroll-down').removeClass('scroll-up');
            } else {
                $('body').addClass('scroll-up').removeClass('scroll-down');
            }

            if ($(document).width() > 1024) {
                if (scroll > position) {
                    // Scroll down
                    if (scroll > headerHeight) {
                        // Cache le header
                        headerSticky = headerHeight;
                        $header.addClass('transition');
                    } else {
                        if (!keepHeaderVisible) {
                            // Cache le header progressivement suivant le scroll
                            headerSticky = scroll;
                            $header.removeClass('transition');
                        }
                    }
                } else {
                    // Scroll Up
                    if (scroll > headerHeight) {
                        // Affiche le header
                        headerSticky = 0;
                        $header.addClass('transition');
                        keepHeaderVisible = true; // Garde le header visible jusqu'en haut de page
                    } else if (keepHeaderVisible) {
                        headerSticky = 0;
                        $header.addClass('transition');
                    } else {
                        // Affiche le header progressivement suivant le scroll
                        headerSticky = scroll;
                        $header.removeClass('transition');
                    }
                }
                if (scroll <= 0) {
                    headerSticky = 0;
                    keepHeaderVisible = false;
                }

                $('#header .header-wrapper').css('transform', 'translateY(-' + headerSticky + 'px)');

                position = scroll;
            } else {
                $('#header .header-wrapper').css('transform', '');
            }
        }

        posHeader();


        // SEARCH
        $('.js_btn-toggle-search').on('click', function () {
            $('html').toggleClass('disable-scroll');
        });


        // MODULE HERO
        if ($('.js_slider-hero .item').length > 1) {
            new Swiper('.js_slider-hero', {
                loop: true,
                speed: 750,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: true,
                },
                navigation: {
                    nextEl: '.js_slider-hero-btn-next',
                    prevEl: '.js_slider-hero-btn-prev',
                },
                });
        }

        $('.js_slider-hero-btn-scroll').on('click', function () {
            $('html,body').stop().animate({
                scrollTop: $(this).offset().top + $(this).outerHeight(true),
            }, 1000);
        });


        // MODULE NEWS SLIDER
        $('.js_news-slider').each(function (index) {
            let elt = this;
            $(elt).siblings('.js_news-slider-btn-prev, .js_news-slider-btn-next').addClass('index-' + (index + 1));

            new Swiper(elt, {
                loop: true,
                speed: 750,
                navigation: {
                    nextEl: '.js_news-slider-btn-next.index-' + (index + 1),
                    prevEl: '.js_news-slider-btn-prev.index-' + (index + 1),
                },
                spaceBetween: 20,
                slidesPerView: 1,
                breakpoints: {
                    601: {
                        slidesPerView: 2,
                    },
                    1025: {
                        slidesPerView: 3,
                        spaceBetween: 39,
                    },
                },
            });

        });

        // MODULE EVENTS SLIDER
        $('.js_events-slider').each(function (index) {
            let elt = this;

            var needLoop = ($(elt).attr('data-count') > 4);
            $(elt).siblings('.js_events-slider-btn-prev, .js_events-slider-btn-next').addClass('index-' + (index + 1));

            new Swiper(elt, {
                loop: needLoop,
                speed: 750,
                navigation: {
                    nextEl: '.js_events-slider-btn-next.index-' + (index + 1),
                    prevEl: '.js_events-slider-btn-prev.index-' + (index + 1),
                },
                spaceBetween: 20,
                slidesPerView: 1,
                breakpoints: {
                    601: {
                        slidesPerView: 2,
                    },
                    961: {
                        slidesPerView: 3,
                        spaceBetween: 23,
                    },
                    1025: {
                        slidesPerView: 4,
                    },
                },
            });

        });


        // MODULE ICONS IMAGES SLIDER
        $('.js_icons-images-slider').each(function (index) {
            let elt = this;

            var needLoop = ($(elt).attr('data-count') > 1);
            $(elt).siblings('.js_icons-images-slider-btn-prev, .js_icons-images-slider-btn-next').addClass('index-' + (index + 1));

            new Swiper(elt, {
                loop: needLoop,
                speed: 750,
                navigation: {
                    nextEl: '.js_icons-images-slider-btn-next.index-' + (index + 1),
                    prevEl: '.js_icons-images-slider-btn-prev.index-' + (index + 1),
                },
                parallax: true,
            });

        });


        // MODULE VIDEO
        $('.js_btn-video').on('click', function () {
            let $elt = $(this);
            let $video = $elt.closest('.video');
            let $iframe = $video.find('iframe');
            let src = 'https://www.youtube-nocookie.com/embed/' + $elt.data('src') + '?rel=0&showinfo=0&enablejsapi=1&autoplay=1&mute=1';
            $iframe.attr('src', src);
            $video.addClass('active');
            $iframe[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        });

        if ($('.banner-page').length < 1) {
          $('.js_btn-video').click()
        }



        // PAGE ANNUAIRE
        $('.js_toggle-filters').on('click', function() {
            $('.js_filters').slideToggle(400);
        });


        // BUTTON BACK TO TOP
        $('.js_btn-scroll-top').on('click', function () {
            $('html,body').stop().animate({
                scrollTop: 0,
            }, 1000);
        });


        // BLUR ON CLICK
        $('a, button, input[type=\'submit\'], .btn').on('click', function () {
            $(this).blur();
        });


        // COOKIE
        let cc = initCookieConsent();

        // run plugin with your configuration
        cc.run({
            current_lang: 'fr',

            gui_options: {
                consent_modal: {
                    layout: 'box',               // box/cloud/bar
                    position: 'bottom left',     // bottom/middle/top + left/right/center
                },
            },
            // si les cookies sont acceptés (ne pas confondre avec le fait de cliquer sur accepter)
            onAccept : function (cookie) {
                document.querySelector('a.cookies-button').classList.add('is-visible');
            },
            onFirstAction: function (cookie) {
                window.location.reload();
            },
            onChange: function (cookie) {
                window.location.reload();
            },

            languages: {
                'fr': {
                    consent_modal: {
                        title: 'Hello ! On vous propose des <span class="large">Cookies</span>',
                        description: 'Ce site utilise des cookies essentiels pour assurer son bon fonctionnement et des cookies de suivi pour comprendre comment vous interagissez avec lui. Ce dernier ne sera fixé qu\'après accord. <button type="button" data-cc="c-settings" class="cc-link">Choisir mes préférences</button>',
                        primary_btn: {
                            text: 'Tout accepter',
                            role: 'accept_all',             // 'accept_selected' or 'accept_all'
                        },
                        secondary_btn: {
                            text: 'Tout rejeter',
                            role: 'accept_necessary',        // 'settings' or 'accept_necessary'
                        },
                    },
                    settings_modal: {
                        title: 'Gestion de préférence des cookies',
                        save_settings_btn: 'Enregistrer',
                        accept_all_btn: 'Tout accepter',
                        reject_all_btn: 'Tout rejeter',
                        close_btn_label: 'Fermer',
                        cookie_table_headers: [
                            {col1: 'Nom'},
                            {col2: 'Domaine'},
                            {col3: 'Expiration'},
                            {col4: 'Description'},
                        ],
                        blocks: [
                            {
                                // title: 'Cookie usage 📢',
                                description: 'Sur ce site, nous utilisons des cookies pour mesurer notre audience. Vous pouvez sélectionner ici les services que vous allez autoriser.',
                        }, {
                            title: 'Cookies nécessaires au bon fonctionnement du site',
                            description: 'Ces cookies sont indispensables au bon fonctionnement du site internet. Ces cookies sont essentiels au bon fonctionnement du site, vous ne pouvez pas les désactiver.',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true,          // cookie categories with readonly=true are all treated as "necessary cookies"
                            },
                        }, {
                            title: "Publicitaires (ou presque)",
                            description: "Pour concevoir ce site nous avons fait appel à une société bien de chez nous (à Nîmes pour être précis) et cette société s’appuie pour rendre votre site plus dynamique sur des technologies tierces : YouTube, openmap, etc… Pour profiter de l’ensemble des technologies nous vous invitons à accepter ces cookies.",
                            toggle: {
                                value: 'advertising',
                                enabled: false,
                                readonly: false
                            }
                        }, {
                            title: 'Google Analytics',
                            description: 'Ces cookies permettent d\'analyser les statistiques de consultation de notre site.',
                            toggle: {
                                value: 'analytics',     // your cookie category
                                enabled: false,
                                readonly: false,
                            },
                            // cookie_table: [             // list of all expected cookies
                            //     {
                            //         col1: '^_ga',       // match all cookies starting with "_ga"
                            //         col2: 'google.com',
                            //         col3: '2 years',
                            //         col4: 'description ...',
                            //         is_regex: true
                            //     },
                            //     {
                            //         col1: '_gid',
                            //         col2: 'google.com',
                            //         col3: '1 day',
                            //         col4: 'description ...',
                            //     }
                            // ]
                            // }, {
                            //     title: 'Advertisement and Targeting cookies',
                            //     description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
                            //     toggle: {
                            //         value: 'targeting',
                            //         enabled: false,
                            //         readonly: false
                            //     }
                            // }, {
                            //     title: 'More information',
                            //     description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="#yourcontactpage">contact us</a>.',
                        },
                        ],
                    },
                },
            },
        });

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};
